var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.23605 1.75C3.7626 1.75 3.32975 2.01751 3.11805 2.44099L2.21352 4.25H17.7864L16.882 2.44099C16.6702 2.01751 16.2374 1.75 15.764 1.75H4.23605ZM18.25 5.75H1.75V17C1.75 17.6903 2.30964 18.25 3 18.25H17C17.6903 18.25 18.25 17.6903 18.25 17V5.75ZM1.7764 1.77016C2.24222 0.838505 3.19445 0.25 4.23605 0.25H15.764C16.8055 0.25 17.7578 0.838505 18.2236 1.77016L19.6708 4.6646C19.7229 4.76875 19.75 4.88355 19.75 5V17C19.75 18.5188 18.5188 19.75 17 19.75H3C1.48122 19.75 0.25 18.5188 0.25 17V5C0.25 4.88355 0.27711 4.76875 0.32918 4.6646L1.7764 1.77016Z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 15C6.75 14.5858 7.0858 14.25 7.5 14.25H12.5C12.9142 14.25 13.25 14.5858 13.25 15C13.25 15.4142 12.9142 15.75 12.5 15.75H7.5C7.0858 15.75 6.75 15.4142 6.75 15Z",
    fill: "#9CA3AF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/Inventory.6930988902f1e3cb12b5ea57e76022b4.svg";
export { ForwardRef as ReactComponent };